import { apiRequest } from "../utils/config/apiRequest"
import { apiUrl } from "../utils/endPoints/apiUrl"



export const getUser = async()=>{
  try{
    const response = await apiRequest({
      endUrl : apiUrl.users.user,
      method: "GET",
    })
    if(response.status === true){
      return{
          success: true,
          data: response.data,
      }
      }else{
        throw new Error(response.message || "Failed");
      }
  }catch(error){
    console.error("Error in Creating User:", error);
    return { success: false, error: error.message };
  }
}


export const getBanklink = async ()=>{
    try{
        const response = await apiRequest({
            endUrl : apiUrl.users.bankLink,
            method : "GET"
        })
        if(response.status === true){
            return{
                success: true,
                data: response.data,
            }
        }else{
          throw new Error(response.message || "Failed");
        }
    }catch(error){
    console.error("Error in Creating User:", error);
    return { success: false, error: error.message };
    }
}


export const updateUser = async (userId, payload) => {
  try {
    const response = await apiRequest({
       endUrl: apiUrl.users.updateUser(userId), 
      method: "PUT",
      body: payload,
    });

    if (response.status === true) {
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    } else {
      throw new Error(response.message || "Failed to update user");
    }
  } catch (error) {
    console.error("Error updating user:", error);
    return { success: false, error: error.message };
  }
};



export const changePassword = async (payload) => {
  try {
    const response = await apiRequest({
      endUrl: apiUrl.users.userChangePassword, 
      method: "POST", 
      body: payload,
    });

    if (response.status === true) {
      return {
        success: true,
        data: response.data,
        message: response.message || "Password changed successfully",
      };
    } else {
      throw new Error(response.message || "Failed to change password");
    }
  } catch (error) {
    console.error("Error changing password:", error);
    return { success: false, error: error.message };
  }
};




